import {
  Modal,
  Box,
  Typography,
  TextField,
  MenuItem,
  Checkbox,
  ListItemText,
  Button,
} from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
  dateStart: string;
  setDateStart: (v: string) => void;
  dateEnd: string;
  setDateEnd: (v: string) => void;
  onFiltrar: () => void;

  clientesInput?: any[];
  clientIds?: string[];
  setClientIds?: (v: string[]) => void;
  obras?: any[];
  workIds?: string[];
  setWorkIds?: (v: string[]) => void;
  movementTypes?: string[];
  setMovementTypes?: (v: string[]) => void;
  origins?: string[];
  setOrigins?: (v: string[]) => void;

  mostraInputCliente?: boolean;
  mostraInputTipoDeMovimentacao?: boolean;
  mostraInputObras?: boolean;
  mostraInputOrigem?: boolean;
  textoBotaoFiltra?: string;
}

export function FiltroMovimentacoesModal({
  open,
  onClose,
  dateStart,
  setDateStart,
  dateEnd,
  setDateEnd,
  onFiltrar,
  clientesInput,
  clientIds,
  setClientIds,
  obras,
  workIds,
  setWorkIds,
  movementTypes,
  setMovementTypes,
  origins,
  setOrigins,
  mostraInputCliente = true,
  mostraInputTipoDeMovimentacao = true,
  mostraInputObras = true,
  mostraInputOrigem = true,
  textoBotaoFiltra = "Filtrar",
}: Props) {
  const originLabels: Record<string, string> = {
    company: "Empresa",
    work: "Obra",
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      }}
    >
      <Box
        p={4}
        borderRadius={2}
        boxShadow={24}
        minWidth={350}
        maxWidth={400}
        mx="auto"
        mt="10vh"
        display="flex"
        flexDirection="column"
        gap={2}
        bgcolor="background.paper" // Use a cor do tema
        color="text.primary"
      >
        <Typography variant="h6">Filtrar Movimentações</Typography>

        <TextField
          label="Data Inicial"
          type="date"
          required
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={dateStart}
          onChange={(e) => setDateStart(e.target.value)}
        />

        <TextField
          label="Data Final"
          type="date"
          required
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={dateEnd}
          onChange={(e) => setDateEnd(e.target.value)}
        />

        {mostraInputCliente && clientesInput && clientIds && setClientIds && (
          <TextField
            select
            label="Clientes"
            fullWidth
            SelectProps={{
              multiple: true,
              renderValue: (selected: any) =>
                clientesInput
                  .filter((cli) => selected.includes(cli.id))
                  .map(
                    (cli) =>
                      cli.corporateName || cli.fantasyName || cli.fullName
                  )
                  .join(", "),
            }}
            value={clientIds}
            onChange={(e) =>
              setClientIds(
                typeof e.target.value === "string"
                  ? e.target.value.split(",")
                  : e.target.value
              )
            }
          >
            {clientesInput.map((cli) => (
              <MenuItem key={cli.id} value={cli.id}>
                <Checkbox checked={clientIds.includes(cli.id)} />
                <ListItemText
                  primary={cli.corporateName || cli.fantasyName || cli.fullName}
                />
              </MenuItem>
            ))}
          </TextField>
        )}

        {mostraInputObras && obras && workIds && setWorkIds && (
          <TextField
            select
            label="Obras"
            fullWidth
            SelectProps={{
              multiple: true,
              renderValue: (selected: any) =>
                obras
                  .filter((obra) => selected.includes(obra.id))
                  .map((obra) => obra.workName)
                  .join(", "),
            }}
            value={workIds}
            onChange={(e) =>
              setWorkIds(
                typeof e.target.value === "string"
                  ? e.target.value.split(",")
                  : e.target.value
              )
            }
          >
            {obras.map((obra) => (
              <MenuItem key={obra.id} value={obra.id}>
                <Checkbox checked={workIds.includes(obra.id)} />
                <ListItemText primary={obra.workName} />
              </MenuItem>
            ))}
          </TextField>
        )}

        {mostraInputTipoDeMovimentacao && movementTypes && setMovementTypes && (
          <TextField
            select
            label="Tipo de Movimentação"
            fullWidth
            SelectProps={{
              multiple: true,
              renderValue: (selected: any) =>
                (selected as string[])
                  .map((type) =>
                    type === "income"
                      ? "Entrada"
                      : type === "outcome"
                      ? "Saída"
                      : type
                  )
                  .join(", "),
            }}
            value={movementTypes}
            onChange={(e) =>
              setMovementTypes(
                typeof e.target.value === "string"
                  ? e.target.value.split(",")
                  : e.target.value
              )
            }
          >
            <MenuItem value="income">
              <Checkbox checked={movementTypes.includes("income")} />
              <ListItemText primary="Entrada" />
            </MenuItem>
            <MenuItem value="outcome">
              <Checkbox checked={movementTypes.includes("outcome")} />
              <ListItemText primary="Saída" />
            </MenuItem>
          </TextField>
        )}

        {mostraInputOrigem && origins && setOrigins && (
          <TextField
            select
            label="Origem da Movimentação"
            fullWidth
            SelectProps={{
              multiple: true,
              renderValue: (selected: any) =>
                (selected as string[])
                  .map((type) => originLabels[type] || type)
                  .join(", "),
            }}
            value={origins}
            onChange={(e) =>
              setOrigins(
                typeof e.target.value === "string"
                  ? e.target.value.split(",")
                  : e.target.value
              )
            }
          >
            {Object.entries(originLabels).map(([value, label]) => (
              <MenuItem key={value} value={value}>
                <Checkbox checked={origins.includes(value)} />
                <ListItemText primary={label} />
              </MenuItem>
            ))}
          </TextField>
        )}

        <Button variant="contained" onClick={onFiltrar}>
          {textoBotaoFiltra}
        </Button>
      </Box>
    </Modal>
  );
}
